import {normalizePermissions} from "./normalizers/userPermission"
export const Urls = {
    "CREATE_TODO": "/ctdo",
    "DIARY_TITLE": "/dtdo"
};

export const getPermission = (userPermission) => {
    let isAdmin, hasActivityAccess, hasWorkkardAccess = false
    const normalizedPermissions = normalizePermissions(userPermission);
    if (
        normalizedPermissions.canAcceptRejectActivity
        || normalizedPermissions.canChangeActivityOwner
        || normalizedPermissions.canCloseActivity
        || normalizedPermissions.canCreateActivity
        || normalizedPermissions.canEditActivity
        || normalizedPermissions.canReassignActivity
        || normalizedPermissions.canReopenActivity
        || normalizedPermissions.canReceiveUnAssignedActivities
        || normalizedPermissions.canArchiveActivity
        || normalizedPermissions.canMarkActivityAsInProgress
        || normalizedPermissions.canCompleteActivity
        || normalizedPermissions.canCloseActivityduringMidterm
        || normalizedPermissions.canAcceptRejectBid
        || normalizedPermissions.canAssignB2B
    )
    {
        hasActivityAccess = true;
    }
    if (
        normalizedPermissions.canArchiveWorkkard
        || normalizedPermissions.canChangeWorkkardSponsor
        || normalizedPermissions.canCreateworkkard
        || normalizedPermissions.canEditWorkkard
        || normalizedPermissions.canReceiveUnAssignedWorkkards
    )
    {
        hasWorkkardAccess = true;
    }
    if (
        normalizedPermissions.canAddUser
        || normalizedPermissions.canEditUser
        || normalizedPermissions.canBlockUser
        || normalizedPermissions.canReAssignUser
        || normalizedPermissions.canResetPassword
        || normalizedPermissions.canManageSettings
        || normalizedPermissions.canManageCompanyProfile
    )
    {
        isAdmin = true;
    }
    return {isAdmin, hasWorkkardAccess, hasActivityAccess}
}

export const getLandingPage = (userView) => {
    const permission = getPermission(userView);

    if (permission.hasWorkkardAccess) {
        return "/workkards";
    } else if (permission.hasActivityAccess) {
        return "/activities";
    }  
    return "/userprofile";    
}

export const exitAdmin = (subdomain, userView) => {
    const host = window.location.host;
    const siteUrl = process.env.siteUrl;    
    const urlScheme = process.env.UrlScheme;
    const landingPage = getLandingPage(userView);
    const isHostLocal = (hostname) => {
        return hostname.includes('localhost') || hostname.includes('127.0.0.1');
    };

    if (
        subdomain &&
        !isHostLocal(host) &&
        !host.startsWith(subdomain)
    ) {
        const bareSubdomain = subdomain.split('.')[0];
        window.location = `${urlScheme}://${bareSubdomain}.${siteUrl}${landingPage}`;
    } else {
        window.location = `${urlScheme}://${siteUrl}${landingPage}`;
    }
}